import { arrow1, arrowCap } from '../lace/arrow'
import { topSidePartOfWeb } from './parts/sideParts'

export const wp4Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  ctx.moveTo(368, 260)
  ctx.quadraticCurveTo(294, 219, 294, 219)
  ctx.stroke()
  ctx.closePath()
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])

  // 上の三角
  ctx.moveTo(234, 262) // 左上
  ctx.quadraticCurveTo(252, 282, 252, 282) // 右下
  ctx.quadraticCurveTo(253, 240, 296, 158) // 右上

  // 模様＿左下_上
  ctx.moveTo(272, 316) // 左上
  ctx.quadraticCurveTo(283, 234, 283, 234) // 右上
  ctx.quadraticCurveTo(345, 297, 345, 297) // 右下

  // 模様＿左下_下
  ctx.moveTo(286, 342) // 左上
  ctx.quadraticCurveTo(292, 283, 292, 283) // 右上
  ctx.quadraticCurveTo(326, 325, 326, 325) // 右下

  // 模様＿右上_上
  ctx.moveTo(354, 107) // 右上
  ctx.quadraticCurveTo(297, 197, 297, 197) // 左下
  ctx.quadraticCurveTo(369, 222, 369, 222) //

  // 模様＿右上_下
  ctx.moveTo(356, 135) // 左上
  ctx.quadraticCurveTo(333, 180, 333, 180) //
  ctx.quadraticCurveTo(364, 192, 364, 192) //

  // 右下のレース下
  ctx.moveTo(370, 257) // 右下＿上
  ctx.quadraticCurveTo(294, 213, 294, 213) // 左上_上
  ctx.quadraticCurveTo(290, 222, 290, 222) // 左上_下
  ctx.quadraticCurveTo(365, 265, 365, 265) // 右下_下

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  arrowCap(ctx, laceColor, -20, -12)
  arrow1(ctx, laceColor, -10, -5)
  arrow1(ctx, laceColor, 3, 2)
  arrow1(ctx, laceColor, 18, 10)
  arrow1(ctx, laceColor, 31, 20)
}
